import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import { FrequencyValue } from '@kaizenplatform/kaizen-chartjs';

export const setLiftUpReportFrequency = (liftUpReportFrequency: FrequencyValue) =>
  produce((draft: Draft<State>) => {
    draft.liftUpReportFrequency.data = liftUpReportFrequency;
  });

export const disposeLiftUpReportFrequency = () =>
  produce((draft: Draft<State>) => {
    draft.liftUpReportFrequency.data = initialState.liftUpReportFrequency.data;
  });
